import React from "react";
import logo from "../assets/images/logo.png";

const Logo = () => {
  return (
    <div>
      <img src={logo} alt="Wealthclub" />
    </div>
  );
};

export default Logo;
